export const getPipelineListGql = `query{mini_program_pipline(_order_by:{create_time:_desc},app_type:$platform){_aggregate{_count},id,app_type,platform,env,mini_appid,mini_branch,custom_branch,artifact_url,remark,create_time,update_time,build_detail}}`;

export const startPipelineGql = `mutation insert {
  mini_program_pipline(_values: {app_type: $app_type, env: $env, mini_appid: $mini_appid, mini_branch: $mini_branch, custom_branch: $custom_branch, remark: $remark})
}`;
